import styled from 'styled-components';

export const StyleScrollbar = styled.div`
  &::-webkit-scrollbar {
    width: 4px; /* 滚动条宽度 */
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--color-fill-3);
    border-radius: 4px; /* 圆角 */
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: var(--color-fill-4); /* 滚动条悬停颜色 */
  }

  &::-webkit-scrollbar-track {
    background-color: var(--color-fill-1); /* 滚动条轨道颜色 */
  }
`;
// 列表项
export const StyleItem = styled.div`
  padding: 0.4rem 0.8rem;
  &:hover {
    background-color: var(--color-fill-2);
    cursor: pointer;
  }
`;

// loading spinner
export const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid var(--color-border);
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
